import * as React from 'react';
import { TrailingContentType, StyleVariant } from '../AmorgMenuTypes';
import { NoneContent } from '../baseContentTypes/NoneContent';
import { IconContent } from '../baseContentTypes/IconContent';
import { TextContent } from '../baseContentTypes/TextContent';

type TrailingContentProps = TrailingContentType &
{
    flex:string,
    styleVariant:StyleVariant,
    isHovering:boolean,
    onClick?:()=>void
}

export function TrailingContent(props:TrailingContentProps):JSX.Element
{
    return (
        <>
            {props.type === 'none' &&
                <NoneContent />    
            }

            {props.type === 'icon' &&
                <IconContent 
                    type='icon' 
                    iconName={props.iconName} 
                    styleVariant={props.styleVariantOverride || props.styleVariant}
                    isHovering={props.onClick && props.isHovering} />
            }

            {props.type === 'text' &&
                <TextContent 
                    type='text' text={props.text}
                    textAlign='right'
                    flex={props.flex}
                    styleVariant={props.styleVariantOverride || props.styleVariant}
                    isHovering={props.onClick && props.isHovering} />
            }
        </>
    );
}